<script setup>
const props = defineProps({
    rippleCount: { type: Number, default: 4 },
    duration: { type: Number, default: 3 },
    delay: { type: Number, default: 0.8 },
    strokeColor: { type: String, default: "#F7F8F8" },
    strokeMin: { type: Number, default: 0.643618 },
    strokeMax: { type: Number, default: 5.14894 },
    centerX: { type: Number, default: 117.595 },
    centerY: { type: Number, default: 35.4439 },
    path: {
        type: String,
        default: () =>
            "M234.028 49.0102C234.028 54.8168 231.177 60.5903 225.511 66.0978C219.838 71.613 211.494 76.6984 200.974 81.024C179.946 89.67 150.718 95.0774 118.301 95.0774C85.8844 95.0774 56.6566 89.67 35.6286 81.024C25.1085 76.6984 16.7647 71.613 11.0912 66.0978C5.4257 60.5903 2.57447 54.8168 2.57447 49.0102C2.57447 43.2037 5.4257 37.4302 11.0912 31.9227C16.7647 26.4075 25.1085 21.322 35.6286 16.9965C56.6566 8.35047 85.8844 2.94312 118.301 2.94312C150.718 2.94312 179.946 8.35047 200.974 16.9965C211.494 21.322 219.838 26.4075 225.511 31.9227C231.177 37.4302 234.028 43.2037 234.028 49.0102Z",
    },
});
</script>

<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 237 98"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
    >
        <g>
            <!-- 中心點 -->
            <ellipse
                :cx="centerX"
                :cy="centerY"
                :rx="0"
                :ry="0"
                fill="white"
                opacity="0"
            >
                <!-- 擴散動畫 -->
                <animate
                    attributeName="rx"
                    values="0;13.3823;0"
                    dur="3s"
                    begin="0.5s"
                    repeatCount="indefinite"
                    keyTimes="0;0.7;1"
                    keySplines="0.4 0 0.2 1;0.4 0 0.2 1"
                    calcMode="spline"
                />
                <animate
                    attributeName="ry"
                    values="0;4.65471;0"
                    dur="3s"
                    begin="0.5s"
                    repeatCount="indefinite"
                    keyTimes="0;0.7;1"
                    keySplines="0.4 0 0.2 1;0.4 0 0.2 1"
                    calcMode="spline"
                />
                <!-- 淡入淡出動畫 -->
                <animate
                    attributeName="opacity"
                    values="0;1;0"
                    dur="3s"
                    begin="0.5s"
                    repeatCount="indefinite"
                    keyTimes="0;0.3;1"
                    keySplines="0.4 0 0.2 1;0.4 0 0.2 1"
                    calcMode="spline"
                />
            </ellipse>

            <!-- 多個 ripple 漣漪動畫 -->
            <g>
                <g v-for="i in rippleCount" :key="i">
                    <path
                        :d="path"
                        :stroke="strokeColor"
                        :stroke-width="strokeMin"
                        fill="none"
                        transform="scale(0)"
                        :transform-origin="`${centerX}px ${centerY}px`"
                    >
                        <animateTransform
                            attributeName="transform"
                            type="scale"
                            from="0"
                            to="1"
                            :dur="duration + 's'"
                            :begin="(i - 1) * delay + 's'"
                            repeatCount="indefinite"
                            additive="replace"
                            calcMode="spline"
                            keySplines="0.42 0 0.58 1"
                        />
                        <animate
                            attributeName="stroke-width"
                            :from="strokeMin"
                            :to="strokeMax"
                            :dur="duration + 's'"
                            :begin="(i - 1) * delay + 's'"
                            repeatCount="indefinite"
                        />
                        <animate
                            attributeName="opacity"
                            values="1;1;1;0.7;0.3;0"
                            keyTimes="0;0.7;0.85;0.92;0.97;1"
                            :dur="duration + 's'"
                            :begin="(i - 1) * delay + 's'"
                            repeatCount="indefinite"
                            calcMode="spline"
                            keySplines="0.25 0.1 0.25 1; 0.4 0 0.6 1; 0.4 0 0.6 1; 0.6 0.2 0.8 1; 0.7 0.2 1 1"
                        />
                    </path>
                </g>
            </g>
        </g>
    </svg>
</template>
